import { CLINIC_TZ } from '@/lib/clinic-time';
import type { EncounterFollowUp } from './api';

/** "Tue 26 Jan, 10:00" in clinic time. */
export function followUpWhen(iso: string): string {
  const p = new Intl.DateTimeFormat('en-GB', {
    timeZone: CLINIC_TZ,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(iso));
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    p.find((x) => x.type === type)?.value ?? '';
  return `${part('weekday')} ${part('day')} ${part('month')}, ${part('hour')}:${part('minute')}`;
}

const NOT_BOOKED: Record<string, string> = {
  no_free_slot: 'no free slot',
  no_service: 'the visit had no service',
};

/**
 * RL-1697: one line on what happened to the follow-up when the consultation
 * closed, for the close toast and the closed consultation. null = none asked.
 */
export function followUpLine(
  f: EncounterFollowUp | null,
): { tone: 'ok' | 'warn'; text: string } | null {
  if (!f) return null;
  const booked = f.status ? f.status === 'booked' : !!f.startsAt;
  if (booked && f.startsAt) {
    const other =
      f.sameDoctor === false && f.doctor ? ` with ${f.doctor.fullName}` : '';
    return {
      tone: 'ok',
      text: `Follow-up booked: ${followUpWhen(f.startsAt)}${other}.`,
    };
  }
  const why = f.reason ? NOT_BOOKED[f.reason] : undefined;
  // Review: only a patient whose app shows "Book your follow-up" was asked;
  // without the app (or a verified link) the desk books it.
  const next = f.patientPrompted
    ? 'The patient was asked to book in the app.'
    : 'Ask the front desk to book it.';
  return {
    tone: 'warn',
    text: why
      ? `Follow-up not booked: ${why}. ${next}`
      : `Follow-up not booked. ${next}`,
  };
}
